/**
 * Conflict resolution methods.
 */
export enum ConflictResolutionMethod {
    KeepLocal = 'KEEP_LOCAL',
    KeepRemote = 'KEEP_REMOTE',
    Merge = 'MERGE',
}
